{
  "#LAGERPLATZ_CORE": {
    "COMPONENTS": {
      "ARTIKEL_MENGE_AUSWAHL": {
        "NO_ITEMS": "Auf diesem Lagerplatz sind keine Artikel vorhanden"
      }
    },
    "DIALOGS": {
      "CHOOSE_LAGERPLATZ": "Lagerplatz auswählen"
    },
    "MESSAGES": {
      "NO_LAGERPLATZ_FOUND": "Zu diesem Barcode konnten keine Lagerplätze gefunden werden"
    }
  },
  "#WWS_CORE": {
    "COMMANDS": {
      "ARTIKELINFO": {
        "NAME": "Artikelinformationen",
        "DIALOG_TITLE": "Artikelinformationen"
      }
    },
    "FOK": {
      "ARTSTAMM": {
        "LIST": {
          "LAGERSTAND": "Lagerstand:"
        },
        "MASTER_DETAIL": {
          "LAGERSTAND": "Lagerstand",
          "VKPREIS": "Verkaufspreis",
          "VKPREIS_INKL": "Verkaufspreis Inkl."
        }
      }
    }
  }
}
